import styles from './Header.module.css';
import mrlogo from './images/M_R-Black.png';
import React, { useState } from "react";

import {
  Link
} from "react-router-dom";

function Header() {

  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  if(click) {
    var itemstyles = styles.nav_options + " " + styles.active;
  }
  else{
    var itemstyles = styles.nav_options;
  }

  var mobileMenuStyles = styles.mobile_menu + " " + styles.headeritem + " " + styles.menu_icon

  return (
    <div class={styles.header}>


        <div className={mobileMenuStyles} onClick={handleClick}>
          
          {click ? (<div class={styles.iconmenuwrapper}>
            <img src="/static/media/M_R-Black.e9ca59c7.png" class="logo" width="50px" alt="marco_rennmaus logo"></img>
            <a className={styles.menu_icon}>Close Menu</a>
          </div>
            
          ) : (
            <div class={styles.iconmenuwrapper}>
            <img src="/static/media/M_R-Black.e9ca59c7.png" class="logo" width="50px" alt="marco_rennmaus logo"></img>
            <a className={styles.menu_icon}>Open Menu</a>
          </div>
          )}
        </div>

        <div className={itemstyles}>
          <a href="/"><img src={mrlogo} className={styles.mrlogodesktop} width="50px" alt="marco_rennmaus logo"></img></a>
          <Link to="/" class={styles.headeritem} onClick={closeMobileMenu}>Homepage</Link>
          <Link to="/dashboard" class={styles.headeritem} onClick={closeMobileMenu}>Dashboard</Link>
          <a href="https://discord.gg/jYGM6V7gae" class={styles.headeritem} onClick={closeMobileMenu}>
            Support Server
          </a>
        </div>
    </div>
  );
}

export default Header;
